import { Image, StyleSheet, Text, View } from 'react-native'
import React from 'react'

const ReportOtp = () => {
  return (
     <Image source={{uri : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/report_otp.png"}} height={100} width={100} />
  )
}

export default ReportOtp

const styles = StyleSheet.create({})